<template>
  <div class="row d-flex">
    <div class="flex sm12 xs12">
      <va-card :title="$t('raffles.cards.title-winners') ">
        <va-data-table
          :fields="campos"
          :data="winners"
          no-data-label="Sem Dados Cadastrados"
          api-mode
        >
        </va-data-table>
      </va-card>
    </div>
    <!-- <div class="flex sm12 xs12">
      <va-card :title="$t('raffles.cards.title-tickets') ">
        <va-data-table
          :fields="fields"
          :data="raffle_tickets"
          :per-page="perPage"
          :totalPages="totalPages"
          :loading="loading"
          @page-selected="showMore"
          no-data-label="Sem Dados Cadastrados"
          api-mode
        >
        </va-data-table>
      </va-card>
    </div> -->
  </div>
</template>

<script>
import gql from 'graphql-tag'

// const perPage = 10
export default {
  name: 'RafflesTickets',
  props: {
    raffle: {
      required: true,
    },
  },
  // methods: {
  //   showMore (page) {
  //     this.loading = true
  //     this.page = page
  //     this.$apollo.queries.raffle_tickets.fetchMore({
  //       variables: {
  //         page: (page - 1) * this.perPage,
  //         perPage: this.perPage,
  //         week: this.week,
  //       },
  //       updateQuery: (_, { fetchMoreResult }) => {
  //         this.loading = false
  //         return fetchMoreResult
  //       },
  //     })
  //   },
  // },
  data () {
    return {
      // raffle_tickets: [],
      winners: [],
      // page: 1,
      // perPage: perPage,
      // pages: null,
      // loading: false,
    }
  },
  apollo: {
    winners: {
      query: gql`
      query MyQuery($raffle: Int) {
        winners: raffle_winners(where: {raffle_id: {_eq: $raffle}, active: {_eq: true}}) {
          id
          client_id
          raffle_id
          client {
            firstName
            lastName
            email
            phone
          }
          prize {
            name
          }
        }
      }
      `,
      variables () {
        return {
          raffle: this.raffle,
        }
      },
    },
    // raffle_tickets: {
    //   query: gql`
    //   query MyQuery($page: Int, $perPage: Int, $raffle: Int!) {
    //     raffle_tickets: raffle_ticket(where: {raffle_id: {_eq: $raffle}}, limit: $perPage, offset: $page) {
    //       client_id
    //       client {
    //         firstName
    //         lastName
    //       }
    //     }
    //   }
    //   `,
    //   variables () {
    //     return {
    //       perPage,
    //       page: 0,
    //       raffle: this.raffle,
    //     }
    //   },
    // },
    // pages: {
    //   query: gql`
    //   query MyQuery($raffle: Int!) {
    //     pages: raffle_ticket_aggregate(where: {raffle_id: {_eq: $raffle}}) {
    //       aggregate {
    //         count
    //       }
    //     }
    //   }
    //   `,
    //   variables () {
    //     return {
    //       raffle: this.raffle,
    //     }
    //   },
    // },
  },
  computed: {
    // totalPages () {
    //   return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    // },
    // fields () {
    //   return [
    //     {
    //       name: 'client_id',
    //       title: this.$t('raffles.headings.client_id'),
    //       dataClass: 'text-center',
    //       width: '100px',
    //     },
    //     {
    //       name: 'client',
    //       title: this.$t('raffles.headings.name'),
    //       callback (value) {
    //         return value.firstName + ' ' + value.lastName
    //       },
    //     },
    //   ]
    // },
    campos () {
      return [
        {
          name: 'client_id',
          title: this.$t('raffles.headings.client_id'),
          dataClass: 'text-center',
          width: '100px',
        },
        {
          name: 'client',
          title: this.$t('raffles.headings.name'),
          callback (value) {
            return value.firstName + ' ' + value.lastName
          },
        },
        {
          name: 'client',
          title: this.$t('raffles.headings.phone'),
          callback (value) {
            return value.phone
          },
        },
        {
          name: 'client',
          title: this.$t('raffles.headings.email'),
          callback (value) {
            return value.email
          },
        },
        {
          name: 'prize',
          title: this.$t('raffles.headings.prize'),
          callback (value) {
            return value.name
          },
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('winners')) {
      // this.$apollo.queries.pages.refetch()
      // this.$apollo.queries.raffle_tickets.refetch()
      this.$apollo.queries.winners.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
